import type { StoreActionApi } from 'react-sweet-state';

import { type SpotlightStore } from '../state/types';

const trigger =
	(id: string) =>
	({ setState, getState }: StoreActionApi<SpotlightStore>) => {
		return setState({ spotlights: { ...getState().spotlights, [id]: true } });
	};

export const actions = {
	trigger,
};
